import React, { useEffect, useRef, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import axios from "axios"
import dayjs from "dayjs"
import { v4 as uuidv4 } from "uuid"
import parse from 'html-react-parser';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import { motion, AnimatePresence } from "motion/react"
import Skeleton from 'react-loading-skeleton'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Overlay from 'react-bootstrap/Overlay';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// import Button from 'react-bootstrap/Button';
import Popover from 'react-bootstrap/Popover';
import ReactSelect from 'react-select';

import fileDownload from "js-file-download"
import { saveAs } from "file-saver"

import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Flex, Progress } from 'antd';
// import { DateRangePicker } from "@heroui/date-picker";
import { ConfigProvider, Pagination } from "antd";

import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Spinner } from 'react-bootstrap';


import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import CustomSpinner from '../components/CustomSpinner';

function Mailer({ serverURL, user, setShowSideOverlay, socket, logToUse, setLogToUse }) {

    const [chosenDateFilter, setChosenDateFilter] = useState(null)


    const [filtersVisible, setFiltersVisible] = useState(false)



    const [allUsers, setAllUsers] = useState(null)

    const [loadingEntries, setLoadingEntries] = useState(true);


    const [currentPageNumber, setCurrentPageNumber] = useState(1)

    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)
    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const [totalMailsForSyncDone, setTotalMailsForSyncDone] = useState(`0/0`)
    const [totalMailsForSyncPercentage, setTotalMailsForSyncPercentage] = useState(100)
    const [counterUserlist, setCounterUserlist] = useState(0)

    const [newEmailsAfterSync, setNewEmailsAfterSync] = useState(0)



    const [filters, setFilters] = useState([])
    const [filtersWithValues, setFiltersWithValues] = useState([])
    const [allMails, setAllMails] = useState(null)
    const [toDomains, settoDomains] = useState(null)
    const [fromDomains, setfromDomains] = useState(null)
    const [dataWithDate, setDataWithDate] = useState(null)
    const [showCalendarFollowup, setShowCalendarFollowup] = useState(false)
    const [showCalendarDeadline, setShowCalendarDeadline] = useState(false)
    const [showCalendarInterviewDate, setShowCalendarInterviewDate] = useState(false)


    const [mailAttachments, setMailAttachments] = useState(null)

    const [interviewDate, setInterviewDate] = useState(new Date())
    const [followDate, setFollowDate] = useState(new Date())
    const [deadlineDate, setDeadlineDate] = useState(new Date())

    const [selectedLabel, setSelectedLabel] = useState(null)

    const [myMessage, setMyMessage] = useState(null)
    const [showMyMessage, setShowMyMessage] = useState(false)

    const [selectedType, setSelectedType] = useState({ "label": "Pending", "value": "Pending" })
    const [isPriorityRequired, setIsPriorityRequired] = useState(false)
    const [priority, setPriority] = useState(null)
    const [isStatusRequired, setIsStatusRequired] = useState(false)
    const [status, setStatus] = useState(null)

    const [isCategoryRequired, setIsCategoryRequired] = useState(false)
    const [categryOption, setCategoryOption] = useState(null)

    const [isCategoryOptionRequired, setIsCategoryOptionRequired] = useState(false)
    const [selectedCategoryOption, setSelectedCategoryOption] = useState(null)

    const [remarks, setRemarks] = useState(null)
    const [isRemarRequired, setIsRemarRequired] = useState(false)


    const [categoryFilter, setCategoryFilter] = useState([])
    const [mailStatusFilter, setMailStatusFilter] = useState([])
    const [actionableFilter, setActionableFilter] = useState([])
    const [priorityFilter, setPriorityFilter] = useState([])
    const [intakeFilter, setIntakeFilter] = useState([])
    const [branchFilter, setBranchFilter] = useState([])


    const [labelOptions, setLabelOptions] = useState({
        "Accommodation": [
            "Docs/Details Required",
            "Dorm Confirmation",
            "Information Only",
            "Rental Contract",
            "WOHNEN Notification",
        ],
        "Admission": [
            "Admission Notification",
            "Admission Received",
            "Docs/Details Required",
            "Important",
            "Information Only",
            "Private | Interview/Admission test",
            "Public | Interview/Admission test",
            "Rejection",
            "Uni-Assist Notification",
            "University Follow-up",
        ],
        "Visa": [
            "Appointment Cancellation",
            "Appointment Confirmation",
            "Approval",
            "Docs/Details Required",
            "Information Only",
            "Rescheduling Confirmation",
            "Slot Opening Notification",
            "Visa Application Dispatched",
            "Waitlisted",
            "Welcome Mail",
        ],
        "Other": ["Spam Mail"]
    })



    const categoryOptions = [
        { value: 'INBOX', label: 'INBOX' },
        { value: 'Junk', label: 'Junk/Spam' },
        { value: 'Draft', label: 'Draft' },
        { value: 'Sent', label: 'Sent' },
        { value: 'Trash', label: 'Trash' },
        { value: 'Archive', label: 'Archive' },
    ]

    const getAllUsers = async () => {

        const getAllStudentNow = await axios.post(serverURL + "/studentMaster/getAllStudentsFromERP")
        // const getAllStudentNow = { "status": 200 }
        if (getAllStudentNow.status === 200) {

            let allStudentsData = getAllStudentNow.data
            // let allStudentsData = [{ "stdYgid": "pratikpisal@accountonlinemail.com", "stdygpassword": "ZB$uT#8K5hb@s4L", "Stdid": "123" }]

            console.log(allStudentsData)

            setAllUsers(allStudentsData)

            getMailsNow(allStudentsData)

            setInterval(() => {
                getMailsNow(allStudentsData)
            }, 600000)

        } else {
            console.log(getAllStudentNow.data)
        }

    }


    // Simulated database insertion function (returns a promise)
    const insertIntoDatabase = (user, category) => {
        return new Promise(async (resolve) => {
            console.log({ "email": user.stdYgid, "password": user.stdygpassword, "category": category.value })
            const getMails = await axios.post(serverURL + "/mails/emails", { "email": user.stdYgid, "password": user.stdygpassword, "limitStart": 0, "limitEnd": 10, "category": category.value });
            if (getMails.status === 200) {
                console.log(category.value + " Done.")
                if (getMails.data.emails) {
                    resolve({ "label": category.value, "value": getMails.data.emails });
                } else {
                    resolve({ "label": category.value, "value": [] });
                }
            } else {
                console.log(getMails.data)
                resolve({ "label": category.value, "value": [] });
            }
        });
    };

    const syncIntoDatabase = (mail, email, leadId, category) => {
        return new Promise(async (resolve) => {
            const dataToSend = {
                "leadId": leadId,
                "attachments": mail.attachments,
                "date": mail.date,
                "from": mail.from,
                "to": email,
                "headerLines": mail.headerLines,
                "headers": mail.headers,
                "html": mail.html,
                "messageId": mail.messageId,
                "subject": mail.subject,
                "text": mail.text,
                "textAsHtml": mail.textAsHtml,
                "mailCategory": category.value,
                "studentId": "",
                "mailStatus": "open",
                "actionable": "pending",
                "departmentalCategory": "",
                "priority": "",
                "followUpDate": "",
                "deadlineDate": "",
                "interviewDate": "",
                "locCode": "",
                "intakeCode": "",
                "updatedBy": {},
                "remarks": {},
                "auditorRemarks": {},
            }
            const getVaue = await axios.post(serverURL + "/mails/syncMail", dataToSend)

            if (getVaue.status === 200) {
                setNewEmailsAfterSync(newEmailsAfterSync + 1)
                return resolve(`${dataToSend.mailCategory}: ${leadId} Synced`)
            } else {
                return resolve("Mail Skipping as exist:" + leadId)
            }
        });
    };

    async function getMailsNow(allUsersData) {

        let userCounter = 0

        for (const user of allUsersData) {

            userCounter++

            setTotalMailsForSyncPercentage((userCounter / allUsersData.length) * 100)

            setCounterUserlist(userCounter)

            let allTypeOfEmails = []
            for (const category of categoryOptions) {
                // console.log(user.email, category.value)
                const repose = await insertIntoDatabase(user, category)
                allTypeOfEmails[repose.label] = repose.value

            }
            console.log(allTypeOfEmails)
            await SyncAllMails(allTypeOfEmails, user.stdYgid, user.Stdid)
        }

        console.log("All Done")
        getAllMailsFromDB(filtersWithValues, filters, entriesLimit, skipEntries)

    }



    const SyncAllMails = async (mailsData, email, leadId) => {
        // console.log(leadId)
        setNewEmailsAfterSync(0)

        for (const category of categoryOptions) {
            let counter = 0
            let total = mailsData[category.value].length
            // console.log(counter, total)
            for (const mail of mailsData[category.value]) {
                const repose = await syncIntoDatabase(mail, email, leadId, category)
                console.log(repose)
                counter += 1

                setTotalMailsForSyncDone(`${counter}/${total}`)

            }
        }
    }

    const getAllMailsFromDB = async (givenFilters, finalFilter, limit, skip) => {
        setLoadingEntries(true)

        console.log(givenFilters)

        let filterToUse = {}
        if (finalFilter.length > 0) {
            finalFilter.map((filterName, key) => {
                console.log(filterName)
                filterToUse[filterName] = { "value": givenFilters[filterName].value, "dbcol": givenFilters[filterName].dbcol }
            })
        }




        const getAllMails = await axios.post(serverURL + "/mails/getAllMailsWithFilters", { "filters": filterToUse, "limit": limit, "skip": skip })
        if (getAllMails.status === 200) {
            const allMessages = getAllMails.data.messages
            const totalMessages = getAllMails.data.total

            // console.log(getAllMails.data)

            let tempDomainFrom = [];
            let tempDomainTo = [];

            allMessages.map((data, key) => {
                let fromCheck = data.from.value[0].address?.split("@")[1]
                let toCheck = data.headerLines.filter((data) => { return data.key === "envelope-to" })[0]?.line.replaceAll("Envelope-to:", "").toLowerCase().split("@")[1]
                let toCheckDummy = data.headerLines.filter((data) => { return data.key === "to" })[0]?.line.replaceAll("To:", "").toLowerCase().split("@")[1]

                if (!tempDomainFrom.includes()) {
                    tempDomainFrom.push(fromCheck)
                }

                if (!tempDomainTo.includes(toCheck)) {

                    if (toCheck) {
                        tempDomainTo.push(toCheck)
                    } else {
                        if (!tempDomainTo.includes(toCheckDummy)) {
                            tempDomainTo.push(toCheckDummy)
                        }

                    }
                }

            })

            setTotalEntriesCount(totalMessages)
            setfromDomains(tempDomainFrom)
            settoDomains(tempDomainTo)
            setAllMails(allMessages)


            const allDates = {}

            allMessages.map((tareekh, key) => {
                const date = dayjs(tareekh.date).format("DD MMMM YYYY")

                Object.keys(allDates)

                if (Object.keys(allDates).includes(date)) {
                    allDates[date].push(tareekh)
                } else {
                    allDates[date] = [tareekh]
                }
            })

            setDataWithDate(allDates)
            setLoadingEntries(false)
        } else {
            console.log(getAllMails.data)
            setDataWithDate(null)
            setLoadingEntries(false)
        }
    }

    const showTheMessage = async (Objid) => {
        const findData = await axios.post(serverURL + "/mails/getMyMessage", { "uid": Objid })
        if (findData.status === 200) {
            const messageData = findData.data

            if (messageData.attachments?.length > 0) {
                console.log(messageData.attachments.refId)

                const getFileInfo = await axios.post(serverURL + "/attachments/getAttachments", { "refId": messageData.attachments.refId })
                if (getFileInfo.status === 200) {
                    console.log(getFileInfo.data)
                    setMailAttachments(getFileInfo.data)
                } else {
                    console.log(getFileInfo.data)
                }
            }

            setMyMessage(messageData)
            setShowMyMessage(true)

            setFollowDate(messageData.followUpDate ? messageData.followUpDate : null)
            setInterviewDate(messageData.interviewDate ? messageData.interviewDate : null)
            setDeadlineDate(messageData.deadlineDate ? messageData.deadlineDate : null)
            setSelectedType(messageData.actionable ? { "label": messageData.actionable, "value": messageData.actionable } : { "label": "pending", "value": "pending" })
            setPriority(messageData.priority ? { "label": messageData.priority, "value": messageData.priority } : null)
            setStatus(messageData.mailStatus ? { "label": messageData.mailStatus, "value": messageData.mailStatus } : null)
            setCategoryOption(messageData.categoryData ? { "label": messageData.categoryData, "value": messageData.categoryData } : null)
            setSelectedCategoryOption(messageData.departmentalCategory ? { "label": messageData.departmentalCategory, "value": messageData.departmentalCategory } : null)
            setSelectedLabel(messageData.categoryData ? labelOptions[messageData?.categoryData] : null)
            setRemarks(messageData.remarks?.value)
        } else {
            setMyMessage(null)
            setShowMyMessage(true)
        }
    }

    const setNewFilter = async (value, filterName, dbCol) => {
        const allFilters = filters
        let allFiltersWithValues = filtersWithValues

        let finalFilter = []


        if (value) {
            if (!allFilters.includes(filterName)) {
                setFilters([...allFilters, filterName])
                finalFilter = [...allFilters, filterName]

                allFiltersWithValues[filterName] = { "value": value, "dbcol": dbCol }

                setFiltersWithValues(allFiltersWithValues)
            } else {
                finalFilter = allFilters
                allFiltersWithValues[filterName] = { "value": value, "dbcol": dbCol }
            }
        } else {
            setFilters(allFilters.filter((fil) => { return fil !== filterName }))
            finalFilter = allFilters.filter((fil) => { return fil !== filterName })

            delete allFiltersWithValues[filterName]
            setFiltersWithValues(allFiltersWithValues)
        }


        // console.log(finalFilter)
        // console.log(allFiltersWithValues)

        if (Object.keys(allFiltersWithValues).length > 0) {
            getAllMailsFromDB(allFiltersWithValues, finalFilter, entriesLimit, skipEntries)
        } else {
            getAllMailsFromDB([], [], entriesLimit, skipEntries)
        }




        // const filterDataNow = await axios.post(serverURL + "/mails/getAllMailsWithFilters", { "filters": allFiltersWithValues, "limit": entriesLimit, "skip": skipEntries })

        // if (filterDataNow.status === 200) {
        //     const allMessages = filterDataNow.data.messages

        //     setTotalEntriesCount(filterDataNow.data.total)

        //     let tempDomainFrom = [];
        //     let tempDomainTo = [];

        //     allMessages.map((data, key) => {
        //         let fromCheck = data.from.value[0].address?.split("@")[1]
        //         let toCheck = data.headerLines.filter((data) => { return data.key === "envelope-to" })[0]?.line.replaceAll("Envelope-to:", "").toLowerCase().split("@")[1]
        //         let toCheckDummy = data.headerLines.filter((data) => { return data.key === "to" })[0]?.line.replaceAll("To:", "").toLowerCase().split("@")[1]

        //         if (!tempDomainFrom.includes()) {
        //             tempDomainFrom.push(fromCheck)
        //         }

        //         if (!tempDomainTo.includes(toCheck)) {

        //             if (toCheck) {
        //                 tempDomainTo.push(toCheck)
        //             } else {
        //                 if (!tempDomainTo.includes(toCheckDummy)) {
        //                     tempDomainTo.push(toCheckDummy)
        //                 }

        //             }
        //         }

        //     })

        //     setfromDomains(tempDomainFrom)
        //     settoDomains(tempDomainTo)
        //     setAllMails(allMessages)


        //     const allDates = {}
        //     allMessages.map((tareekh, key) => {
        //         const date = dayjs(tareekh.date).format("DD MMMM YYYY, dddd")

        //         Object.keys(allDates)

        //         if (Object.keys(allDates).includes(date)) {
        //             allDates[date].push(tareekh)
        //         } else {
        //             allDates[date] = [tareekh]
        //         }
        //     })
        //     setDataWithDate(allDates)
        //     setLoadingEntries(false)
        // } else {
        //     setTotalEntriesCount(0)
        //     console.log(filterDataNow.data)
        //     setAllMails(null)
        //     setDataWithDate(null)
        //     setLoadingEntries(false)
        // }
    }

    const updateThisEmail = async (event, id) => {
        event.preventDefault()


        const typeData = selectedType?.value
        const categoryData = categryOption?.value
        const categoryOptionData = selectedCategoryOption?.value
        const priorityData = priority?.value
        const statusData = status?.value
        const followUpTimeData = document.getElementById("followUpTime")
        const deadlineTimeData = document.getElementById("deadlineTime")
        const interviewTimeData = document.getElementById("interviewDateTime")
        const remarksData = remarks

        if (typeData === "Pending") {
            alert("Type should not be pending")
            return
        } else if (typeData === "Actionable") {
            const sendData = {
                "id": id,
                "data": {
                    "actionable": typeData,
                    "categoryData": categoryData,
                    "departmentalCategory": categoryOptionData,
                    "priority": priorityData,
                    "mailStatus": statusData,
                    "interviewDate": dayjs(interviewDate).hour(interviewTimeData.value.split(":")[0]).minute(interviewTimeData.value.split(":")[1]).$d,
                    "followUpDate": dayjs(followDate).hour(followUpTimeData.value.split(":")[0]).minute(followUpTimeData.value.split(":")[1]).$d,
                    "deadlineDate": dayjs(deadlineDate).hour(deadlineTimeData.value.split(":")[0]).minute(deadlineTimeData.value.split(":")[1]).$d,
                    "updatedBy": { "email": user ? user.email : "sampleEmail", "time": dayjs().$d },
                    "remarks": { "email": "useremail", "value": remarksData },
                }
            }

            console.log(sendData)


            const updateValueNow = await axios.post(serverURL + "/mails/updateEmail", sendData)

            if (updateValueNow.status === 200) {
                console.log(updateValueNow.data)
                setShowMyMessage(false)

                setFollowDate(new Date())
                setInterviewDate(new Date())
                setDeadlineDate(new Date())
                setSelectedLabel(null)
                setSelectedType({ "label": "Pending", "value": "Pending" })
                setIsPriorityRequired(false)
                setPriority(null)
                setIsStatusRequired(false)
                setStatus(null)
                setIsCategoryRequired(false)
                setCategoryOption(null)
                setIsCategoryOptionRequired(false)
                setSelectedCategoryOption(null)
                setRemarks(null)
            } else {
                console.log(updateValueNow.data)
            }
        } else {
            const sendData = {
                "id": id,
                "data": {
                    "actionable": typeData,
                    "categoryData": categoryData,
                    "departmentalCategory": categoryOptionData,
                    "priority": "low",
                    "mailStatus": "close",
                    "followUpDate": dayjs(followDate).hour(followUpTimeData.value.split(":")[0]).minute(followUpTimeData.value.split(":")[1]).$d,
                    "deadlineDate": dayjs(deadlineDate).hour(deadlineTimeData.value.split(":")[0]).minute(deadlineTimeData.value.split(":")[1]).$d,
                    "updatedBy": { "email": user ? user.email : "sampleEmail", "time": dayjs().$d },
                    "remarks": { "email": "useremail", "value": remarksData },
                }
            }

            console.log(sendData)


            const updateValueNow = await axios.post(serverURL + "/mails/updateEmail", sendData)

            if (updateValueNow.status === 200) {
                console.log(updateValueNow.data)
                setShowMyMessage(false)

                setFollowDate(new Date())
                setInterviewDate(new Date())
                setDeadlineDate(new Date())
                setSelectedLabel(null)
                setSelectedType({ "label": "Pending", "value": "Pending" })
                setIsPriorityRequired(false)
                setPriority(null)
                setIsStatusRequired(false)
                setStatus(null)
                setIsCategoryRequired(false)
                setCategoryOption(null)
                setIsCategoryOptionRequired(false)
                setSelectedCategoryOption(null)
                setRemarks(null)
            } else {
                console.log(updateValueNow.data)
            }
        }



    }

    const makeMandatoryFormOrNot = (value) => {
        const followUpTimeData = document.getElementById("followUpTime")
        const deadlineTimeData = document.getElementById("deadlineTime")

        if (value === "Actionable") {
            setIsPriorityRequired(true)
            setIsStatusRequired(true)
            setIsCategoryRequired(true)
            setIsCategoryOptionRequired(true)
            followUpTimeData.required = true
            deadlineTimeData.required = true
            setIsRemarRequired(true)
        } else if (value === "no-action") {
            setIsPriorityRequired(false)
            setIsStatusRequired(false)
            setIsCategoryRequired(true)
            setIsCategoryOptionRequired(true)
            followUpTimeData.required = false
            deadlineTimeData.required = false
            setIsRemarRequired(false)
        } else {
            setIsPriorityRequired(true)
            setIsStatusRequired(true)
            setIsCategoryRequired(true)
            setIsCategoryOptionRequired(true)
            followUpTimeData.required = true
            deadlineTimeData.required = true
            setIsRemarRequired(true)
        }
    }



    function downloadBufferAsFile(bufferData, mimeType, filename) {
        // Step 1: Convert buffer data to Uint8Array
        const byteArray = new Uint8Array(bufferData);

        // Step 2: Create a Blob from the Uint8Array
        const blob = new Blob([byteArray], { type: mimeType });

        // Step 3: Generate a temporary download URL
        const url = URL.createObjectURL(blob);

        // Step 4: Create a link element
        const link = document.createElement("a");
        link.href = url;
        link.download = filename; // Specify the desired file name

        // Step 5: Programmatically trigger a click
        link.click();

        // Step 6: Clean up the URL object
        URL.revokeObjectURL(url);
    }




    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();

    const [csvDataToExport, setCsvDataToExport] = useState(null)
    const [preparingCSV, setPreparingCSV] = useState(false)


    const exportEmailData = async () => {
        setPreparingCSV(true)
        setCsvDataToExport(null)
        const getAllMails = await axios.post(serverURL + "/mails/getAllMails", { "skip": skipEntries, "limit": entriesLimit })
        if (getAllMails.status === 200) {
            // console.log(getAllMails.data.messages)

            let finalCSVFormat = []

            const allData = getAllMails.data.messages

            let labelArrays = []
            Object.keys(allData[0]).map((keynames, key) => {
                return labelArrays.push(keynames)
            })

            let filteredLabels = labelArrays.filter((label) => {
                return (
                    label !== "attachments"
                    &&
                    label !== "headerLines"
                    &&
                    label !== "textAsHtml"
                    &&
                    label !== "html"
                    &&
                    label !== "text"
                    &&
                    label !== "_id"
                    &&
                    label !== "studentRefId"
                    &&
                    label !== "from"
                    &&
                    label !== "__v"
                )
            })

            finalCSVFormat.push(filteredLabels)

            allData.map((message, key) => {
                let currentData = []
                filteredLabels.map((label, key) => {
                    if (label === "date" || label === "updatedAt" || label === "createdAt" || label === "followUpDate" || label === "deadlineDate" || label === "interviewDate") {
                        if (dayjs(message[label]).isValid()) {
                            currentData.push(dayjs(message[label]).format("DD MMM YYYY, h:mma"))
                        } else {
                            currentData.push(message[label])
                        }
                    } else {
                        currentData.push(message[label])
                    }
                })
                finalCSVFormat.push(currentData)
            })

            setCsvDataToExport(finalCSVFormat)


            const blob = new Blob([jsonToCSV(finalCSVFormat)], { type: 'text/csv' });

            // Create a data URL from the Blob
            const url = URL.createObjectURL(blob);

            // Create a temporary anchor element
            const a = document.createElement('a');
            a.href = url;
            a.download = "MailsBackup " + dayjs().format("DD MMM YYYY HH:mm:ss") + ".csv"; // Set the filename
            a.click();

            setPreparingCSV(false)
            setCsvDataToExport(null)

        } else {
            console.log(getAllMails.data)
            setPreparingCSV(false)
            setCsvDataToExport(null)
        }
    }



    useEffect(() => {
        // console.log(chosenDateFilter)
        if (chosenDateFilter) {
            setNewFilter(chosenDateFilter, "dateSearch", "date")
        }

    }, [chosenDateFilter])



    useEffect(() => {
        getAllMailsFromDB(filtersWithValues, filters, entriesLimit, skipEntries)
    }, [skipEntries, entriesLimit])

    useEffect(() => {
        getAllMailsFromDB(filtersWithValues, filters, entriesLimit, skipEntries)

        const url = window.location.href

        if (url.includes("?")) {
            const query = decodeURIComponent(url.split("?")[1].toLocaleLowerCase())
            setActionableFilter([...query.split("=")[1].replaceAll("+", "-").split(",")])
            setNewFilter([...query.split("=")[1].split(",")], "actionableSearch", "actionable")
        }
    }, [])

    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 border-0 d-flex justify-content-between">
                    <span>YG Mailer</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='my-3 d-flex flex-column gap-2 align-items-start'>
                    {
                        allUsers &&
                        <div className='d-flex w-100 align-items-center'>
                            <Progress
                                percent={totalMailsForSyncPercentage.toFixed(2)}
                                strokeColor={{ from: '#108ee9', to: '#87d068' }}
                                percentPosition={{ align: 'start', type: 'inner' }}
                                size={["100%", 20]}
                                status={totalMailsForSyncPercentage < 100 ? "active" : "success"}
                            />
                            <span className='d-flex align-items-center'>{counterUserlist.toString().padStart(allUsers.length.toString().length, "0")}/{allUsers.length}</span>
                        </div>
                    }

                    <div className='d-flex gap-3 align-items-center'>
                        <div className='btn btn-outline-dark rounded-2 m-0 d-flex' disabled={preparingCSV} onClick={() => { exportEmailData() }}>
                            {
                                preparingCSV ?
                                    <div className='d-flex align-items-center gap-1'>
                                        <CustomSpinner size={.3} />
                                        Preparing Data
                                    </div>
                                    :
                                    <div className='d-flex align-items-center gap-1'>
                                        <FileDownloadIcon />
                                        CSV
                                    </div>

                            }
                        </div>
                        <AnimatePresence>
                            <motion.button
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: .5 }}
                                className='btn btn-outline-dark rounded-2 m-0 d-flex'
                                title='Show Filters'
                                onClick={() => {
                                    setFiltersVisible(!filtersVisible); if (filtersVisible) {
                                        setFilters([]);
                                        setCategoryFilter([]);
                                        setMailStatusFilter([]);
                                        setActionableFilter([]);
                                        setPriorityFilter([]);
                                        setIntakeFilter([]);
                                        setBranchFilter([]);
                                    }
                                }}>
                                {
                                    filtersVisible ?
                                        <CloseIcon />
                                        :
                                        <FilterListIcon />
                                }
                            </motion.button>
                        </AnimatePresence>
                    </div>

                    <AnimatePresence>
                        {
                            filtersVisible &&
                            <motion.div
                                initial={{ opacity: 0, height: "0%" }}
                                animate={{ opacity: 1, height: "100%" }}
                                exit={{ opacity: 0, height: "0%" }}
                                transition={{ duration: .5 }}
                                className='d-flex align-items-center gap-3 w-100 justify-content-between glassInfo overflow-hidden'>

                                <div className='d-flex gap-3 flex-wrap justify-content-center align-items-center'>
                                    <div className='w-100' style={{ maxWidth: "300px" }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateRangePicker
                                                slots={{ field: SingleInputDateRangeField }}
                                                name="allowedRange"
                                                id="dateSearch"
                                                data-dbcol="date"
                                                className='w-100'
                                                label="Recieved On"
                                                variant="standard"
                                                onChange={(e) => {
                                                    setChosenDateFilter({ "Start": dayjs(e[0]?.$d).format("YYYY-MM-DD"), "End": dayjs(e[1]?.$d).format("YYYY-MM-DD") })
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>

                                    <FormControl variant="outlined" sx={{ width: 300 }}>
                                        <InputLabel id="mailCategoryLabel">Mailbox Category</InputLabel>
                                        <Select
                                            labelId="mailCategory"
                                            multiple
                                            value={categoryFilter}
                                            id="categorySearch"
                                            data-dbcol="mailCategory"
                                            onChange={(e) => {
                                                // setCategoryFilter(e.target.value)
                                                // setNewFilter(e.target.value, "categorySearch", "mailCategory")
                                            }}
                                            input={<OutlinedInput label="Mailbox Category" />}
                                            renderValue={(selected) => selected.join(', ')}
                                        >
                                            <MenuItem value={"all"} onClick={(e) => {
                                                if (categoryFilter.includes('all')) {
                                                    setCategoryFilter([])
                                                    console.log("All Unselected")
                                                    setNewFilter(null, "categorySearch", "mailCategory")
                                                } else {
                                                    console.log("All Selected")
                                                    setCategoryFilter(['all', ...categoryOptions.map((keyname, key) => { return keyname.value })])
                                                    setNewFilter([...categoryOptions.map((keyname, key) => { return keyname.value })], "categorySearch", "mailCategory")
                                                }
                                            }}>
                                                <Checkbox checked={categoryFilter?.includes("all")} />
                                                <ListItemText primary={"all"} />
                                            </MenuItem>
                                            {
                                                categoryOptions.map((name, key) => (
                                                    <MenuItem key={key} value={name.value} onClick={(e) => {
                                                        if (categoryFilter.includes(name.value)) {
                                                            if (categoryFilter.includes('all')) {
                                                                console.log('all and labeled')
                                                                setCategoryFilter(categoryFilter.filter((data, key) => { return data !== 'all' && data !== name.value }))
                                                                setNewFilter(categoryFilter.filter((data, key) => { return data !== 'all' && data !== name.value }), "categorySearch", "mailCategory")
                                                            } else {
                                                                console.log('not all and labeled')
                                                                setCategoryFilter([...categoryFilter.filter((keyname, key) => { return keyname !== name.value })])
                                                                setNewFilter([...categoryFilter.filter((keyname, key) => { return keyname !== name.value })], "categorySearch", "mailCategory")
                                                            }
                                                        } else {
                                                            console.log('not all and not labeled')
                                                            setCategoryFilter([name.value, ...categoryFilter])
                                                            setNewFilter([name.value, ...categoryFilter], "categorySearch", "mailCategory")
                                                        }
                                                    }}>
                                                        <Checkbox checked={categoryFilter?.includes(name.value)} />
                                                        <ListItemText primary={name.value} />
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    <FormControl variant="outlined" sx={{ width: 300 }}>
                                        <InputLabel id="statusSearchLabel">Mail Status</InputLabel>
                                        <Select
                                            labelId="statusSearch"
                                            multiple
                                            value={mailStatusFilter}
                                            id="statusSearch"
                                            data-dbcol="mailStatus"
                                            onChange={(e) => {
                                                //  setNewFilter(e.target.value, "statusSearch", "mailStatus") 
                                            }}
                                            input={<OutlinedInput label="mailStatus" />}
                                            renderValue={(selected) => selected.join(', ')}
                                        >

                                            <MenuItem value={"all"} onClick={(e) => {
                                                if (mailStatusFilter.includes('all')) {
                                                    setMailStatusFilter([])
                                                    setNewFilter(null, "statusSearch", "mailStatus")
                                                } else {
                                                    setMailStatusFilter(['all', ...["open", "closed", "in-process", "in-process-by-student", "re-open"].map((statusLables, key) => { return statusLables })])
                                                    setNewFilter([...["open", "closed", "in-process", "in-process-by-student", "re-open"].map((statusLables, key) => { return statusLables })], "statusSearch", "mailStatus")
                                                }
                                            }}>
                                                <Checkbox checked={mailStatusFilter?.includes("all")} />
                                                <ListItemText primary={"all"} />
                                            </MenuItem>
                                            {
                                                ["open", "closed", "in-process", "in-process-by-student", "re-open"].map((statusLables, key) => (
                                                    <MenuItem key={key} value={statusLables} onClick={(e) => {
                                                        if (mailStatusFilter.includes(statusLables)) {
                                                            if (mailStatusFilter.includes('all')) {
                                                                console.log('all and labeled')
                                                                setMailStatusFilter(mailStatusFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }))
                                                                setNewFilter(mailStatusFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }), "statusSearch", "mailStatus")

                                                            } else {
                                                                console.log('not all and labeled')
                                                                setMailStatusFilter([...mailStatusFilter.filter((keyname, key) => { return keyname !== statusLables })])
                                                                setNewFilter([...mailStatusFilter.filter((keyname, key) => { return keyname !== statusLables })], "statusSearch", "mailStatus")

                                                            }
                                                        } else {
                                                            console.log('not all and not labeled')
                                                            setMailStatusFilter([statusLables, ...mailStatusFilter.filter((keyname, key) => { return keyname })])
                                                            setNewFilter([statusLables, ...mailStatusFilter.filter((keyname, key) => { return keyname })], "statusSearch", "mailStatus")
                                                        }
                                                    }}>
                                                        <Checkbox checked={mailStatusFilter?.includes(statusLables)} />
                                                        <ListItemText primary={statusLables} />
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    <FormControl variant="outlined" sx={{ width: 300 }}>
                                        <InputLabel id="actionableSearchLabel">Actionable</InputLabel>
                                        <Select
                                            labelId="Actionable"
                                            multiple
                                            value={actionableFilter}
                                            id="actionableSearch"
                                            data-dbcol="actionable"
                                            onChange={(e) => {
                                                // setNewFilter(e.target.value, "actionableSearch", "actionable")
                                            }}
                                            input={<OutlinedInput label="Actionable" />}
                                            renderValue={(selected) => selected.join(', ')}
                                        >
                                            <MenuItem value={"all"} onClick={(e) => {
                                                if (actionableFilter.includes('all')) {
                                                    setActionableFilter([])
                                                    setNewFilter(null, "actionableSearch", "actionable")

                                                } else {
                                                    setActionableFilter(['all', ...["pending", "actionable", "no-action"].map((statusLables, key) => { return statusLables })])
                                                    setNewFilter([...["pending", "actionable", "no-action"].map((statusLables, key) => { return statusLables })], "actionableSearch", "actionable")
                                                }
                                            }}>
                                                <Checkbox checked={actionableFilter?.includes("all")} />
                                                <ListItemText primary={"all"} />
                                            </MenuItem>
                                            {
                                                ["pending", "actionable", "no-action"].map((statusLables, key) => (
                                                    <MenuItem key={key} value={statusLables} onClick={(e) => {
                                                        if (actionableFilter.includes(statusLables)) {
                                                            if (actionableFilter.includes('all')) {
                                                                console.log('all and labeled')
                                                                setActionableFilter(actionableFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }))
                                                                setNewFilter(actionableFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }), "actionableSearch", "actionable")

                                                            } else {
                                                                console.log('not all and labeled')
                                                                setActionableFilter([...actionableFilter.filter((keyname, key) => { return keyname !== statusLables })])
                                                                setNewFilter([...actionableFilter.filter((keyname, key) => { return keyname !== statusLables })], "actionableSearch", "actionable")
                                                            }
                                                        } else {
                                                            console.log('not all and not labeled')
                                                            setActionableFilter([statusLables, ...actionableFilter.filter((keyname, key) => { return keyname })])
                                                            setNewFilter([statusLables, ...actionableFilter.filter((keyname, key) => { return keyname })], "actionableSearch", "actionable")
                                                        }
                                                    }}>
                                                        <Checkbox checked={actionableFilter?.includes(statusLables)} />
                                                        <ListItemText primary={statusLables} />
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    <FormControl variant="outlined" sx={{ width: 300 }}>
                                        <InputLabel id="prioritySearchLabel">Priority</InputLabel>
                                        <Select
                                            labelId="prioritySearch"
                                            id="prioritySearch"
                                            multiple
                                            value={priorityFilter}
                                            data-dbcol="priority"
                                            onChange={(e) => {
                                                // setNewFilter(e.target.value, "prioritySearch", "priority") 
                                            }}
                                            input={<OutlinedInput label="Priority" />}
                                            renderValue={(selected) => selected.join(', ')}
                                        >
                                            <MenuItem value={"all"} onClick={(e) => {
                                                if (priorityFilter.includes('all')) {
                                                    setPriorityFilter([])
                                                    setNewFilter(null, "prioritySearch", "priority")
                                                } else {
                                                    setPriorityFilter(['all', ...["low", "medium", "high"].map((statusLables, key) => { return statusLables })])
                                                    setNewFilter([...["low", "medium", "high"].map((statusLables, key) => { return statusLables })], "prioritySearch", "priority")
                                                }
                                            }}>
                                                <Checkbox checked={priorityFilter?.includes("all")} />
                                                <ListItemText primary={"all"} />
                                            </MenuItem>
                                            {
                                                ["low", "medium", "high"].map((statusLables, key) => (
                                                    <MenuItem key={key} value={statusLables} onClick={(e) => {
                                                        if (priorityFilter.includes(statusLables)) {
                                                            if (priorityFilter.includes('all')) {
                                                                console.log('all and labeled')
                                                                setPriorityFilter(priorityFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }))
                                                                setNewFilter(priorityFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }), "prioritySearch", "priority")
                                                            } else {
                                                                console.log('not all and labeled')
                                                                setPriorityFilter([...priorityFilter.filter((keyname, key) => { return keyname !== statusLables })])
                                                                setNewFilter([...priorityFilter.filter((keyname, key) => { return keyname !== statusLables })], "prioritySearch", "priority")
                                                            }
                                                        } else {
                                                            console.log('not all and not labeled')
                                                            setPriorityFilter([statusLables, ...priorityFilter.filter((keyname, key) => { return keyname })])
                                                            setNewFilter([statusLables, ...priorityFilter.filter((keyname, key) => { return keyname })], "prioritySearch", "priority")
                                                        }
                                                    }}>
                                                        <Checkbox checked={priorityFilter?.includes(statusLables)} />
                                                        <ListItemText primary={statusLables} />
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    <FormControl variant="outlined" sx={{ width: 300 }}>
                                        <InputLabel id="intakeSearchLabel">Intake</InputLabel>
                                        <Select
                                            labelId="intakeSearch"
                                            id="intakeSearch"
                                            multiple
                                            value={intakeFilter}
                                            data-dbcol="intakeCode"
                                            onChange={(e) => {
                                                //  setNewFilter(e.target.value, "intakeSearch", "priority") 
                                            }}
                                            input={<OutlinedInput label="Intake" />}
                                            renderValue={(selected) => {
                                                selected.map((statusLables, key) => {
                                                    if (statusLables === "11") { return "NA" }
                                                    else if (statusLables === "13") { return "Summer 2020" }
                                                    else if (statusLables === "11") { return "Summer 2020" }
                                                    else if (statusLables === "12") { return "Summer 2021" }
                                                    else if (statusLables === "6") { return "Summer 2022" }
                                                    else if (statusLables === "8") { return "Summer 2023" }
                                                    else if (statusLables === "2") { return "Summer 2024" }
                                                    else if (statusLables === "4") { return "Summer 2025" }
                                                    else if (statusLables === "10") { return "Summer 2026" }
                                                    else if (statusLables === "16") { return "Summer 2027" }
                                                    else if (statusLables === "14") { return "Winter 2020" }
                                                    else if (statusLables === "15") { return "Winter 2021" }
                                                    else if (statusLables === "7") { return "Winter 2022" }
                                                    else if (statusLables === "1") { return "Winter 2023" }
                                                    else if (statusLables === "3") { return "Winter 2024" }
                                                    else if (statusLables === "5") { return "Winter 2025" }
                                                    else if (statusLables === "9") { return "Winter 2026" }
                                                    else if (statusLables === "17") { return "Winter 2027" }
                                                    else { return "NA" }
                                                }).join(", ")
                                            }}
                                        >
                                            <MenuItem value={"all"} onClick={(e) => {
                                                if (intakeFilter.includes('all')) {
                                                    setIntakeFilter([])
                                                    setNewFilter(null, "intakeSearch", "intakeCode")
                                                } else {
                                                    setIntakeFilter(['all', ...["11", "13", "12", "6", "8", "2", "4", "10", "16", "14", "15", "7", "1", "3", "5", "9", "17"].map((statusLables, key) => { return statusLables })])
                                                    setNewFilter([...["0", "11", "13", "12", "6", "8", "2", "4", "10", "16", "14", "15", "7", "1", "3", "5", "9", "17"].map((statusLables, key) => { return statusLables })], "intakeSearch", "intakeCode")
                                                }
                                            }}>
                                                <Checkbox checked={intakeFilter?.includes("all")} />
                                                <ListItemText primary={"all"} />
                                            </MenuItem>
                                            {
                                                ["11", "13", "12", "6", "8", "2", "4", "10", "16", "14", "15", "7", "1", "3", "5", "9", "17"].map((statusLables, key) => (
                                                    <MenuItem key={key} value={statusLables} onClick={(e) => {
                                                        if (intakeFilter.includes(statusLables)) {
                                                            if (intakeFilter.includes('all')) {
                                                                console.log('all and labeled')
                                                                setIntakeFilter(intakeFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }))
                                                                setNewFilter(intakeFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }), "intakeSearch", "intakeCode")
                                                            } else {
                                                                console.log('not all and labeled')
                                                                setIntakeFilter([...intakeFilter.filter((keyname, key) => { return keyname !== statusLables })])
                                                                setNewFilter([...intakeFilter.filter((keyname, key) => { return keyname !== statusLables })], "intakeSearch", "intakeCode")
                                                            }
                                                        } else {
                                                            console.log('not all and not labeled')
                                                            setIntakeFilter([statusLables, ...intakeFilter.filter((keyname, key) => { return keyname })])
                                                            setNewFilter([statusLables, ...intakeFilter.filter((keyname, key) => { return keyname })], "intakeSearch", "intakeCode")
                                                        }
                                                    }}>
                                                        <Checkbox checked={intakeFilter?.includes(statusLables)} />
                                                        {
                                                            statusLables === "11" ?
                                                                <ListItemText primary={"NA"} />
                                                                :
                                                                statusLables === "13" ?
                                                                    <ListItemText primary={"Summer 2020"} />
                                                                    :
                                                                    statusLables === "12" ?
                                                                        <ListItemText primary={"Summer 2021"} />
                                                                        :
                                                                        statusLables === "6" ?
                                                                            <ListItemText primary={"Summer 2022"} />
                                                                            :
                                                                            statusLables === "8" ?
                                                                                <ListItemText primary={"Summer 2023"} />
                                                                                :
                                                                                statusLables === "2" ?
                                                                                    <ListItemText primary={"Summer 2024"} />
                                                                                    :
                                                                                    statusLables === "4" ?
                                                                                        <ListItemText primary={"Summer 2025"} />
                                                                                        :
                                                                                        statusLables === "10" ?
                                                                                            <ListItemText primary={"Summer 2026"} />
                                                                                            :
                                                                                            statusLables === "16" ?
                                                                                                <ListItemText primary={"Summer 2027"} />
                                                                                                :
                                                                                                statusLables === "14" ?
                                                                                                    <ListItemText primary={"Winter 2020"} />
                                                                                                    :
                                                                                                    statusLables === "15" ?
                                                                                                        <ListItemText primary={"Winter 2021"} />
                                                                                                        :
                                                                                                        statusLables === "7" ?
                                                                                                            <ListItemText primary={"Winter 2022"} />
                                                                                                            :
                                                                                                            statusLables === "1" ?
                                                                                                                <ListItemText primary={"Winter 2023"} />
                                                                                                                :
                                                                                                                statusLables === "3" ?
                                                                                                                    <ListItemText primary={"Winter 2024"} />
                                                                                                                    :
                                                                                                                    statusLables === "5" ?
                                                                                                                        <ListItemText primary={"Winter 2025"} />
                                                                                                                        :
                                                                                                                        statusLables === "9" ?
                                                                                                                            <ListItemText primary={"Winter 2026"} />
                                                                                                                            :
                                                                                                                            statusLables === "17" ?
                                                                                                                                <ListItemText primary={"Winter 2027"} />
                                                                                                                                :
                                                                                                                                "NA"
                                                        }

                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    <FormControl variant="outlined" sx={{ width: 300 }}>
                                        <InputLabel id="BranchSearchLabel">Branch</InputLabel>
                                        <Select
                                            labelId="branchSearch"
                                            id="branchSearch"
                                            multiple
                                            value={branchFilter}
                                            data-dbcol="locCode"
                                            onChange={(e) => {
                                                // setNewFilter(e.target.value, "branchSearch", "branch") 
                                            }}
                                            input={<OutlinedInput label="Branch" />}
                                            renderValue={(selected) => selected.join(', ')}
                                        >
                                            <MenuItem value={"all"} onClick={(e) => {
                                                if (branchFilter.includes('all')) {
                                                    setBranchFilter([])
                                                    setNewFilter(null, "branchSearch", "locCode")
                                                } else {
                                                    setBranchFilter(['all', ...["0", "20", "5", "6", "4", "7", "13", "11", "2", "1", "14", "23", "22", "21", "18", "8", "9", "12", "19", "17", "10", "16", "15"].map((statusLables, key) => { return statusLables })])
                                                    setNewFilter([...["0", "20", "5", "6", "4", "7", "13", "11", "2", "1", "14", "23", "22", "21", "18", "8", "9", "12", "19", "17", "10", "16", "15"].map((statusLables, key) => { return statusLables })], "branchSearch", "locCode")
                                                }
                                            }}>
                                                <Checkbox checked={branchFilter?.includes("all")} />
                                                <ListItemText primary={"all"} />
                                            </MenuItem>
                                            {
                                                ["0", "20", "5", "6", "4", "7", "13", "11", "2", "1", "14", "23", "22", "21", "18", "8", "9", "12", "19", "17", "10", "16", "15"].map((statusLables, key) => (
                                                    <MenuItem key={key} value={statusLables} onClick={(e) => {
                                                        if (branchFilter.includes(statusLables)) {
                                                            if (branchFilter.includes('all')) {
                                                                console.log('all and labeled')
                                                                setBranchFilter(branchFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }))
                                                                setNewFilter(branchFilter.filter((data, key) => { return data !== 'all' && data !== statusLables }), "branchSearch", "locCode")
                                                            } else {
                                                                console.log('not all and labeled')
                                                                setBranchFilter([...branchFilter.filter((keyname, key) => { return keyname !== statusLables })])
                                                                setNewFilter([...branchFilter.filter((keyname, key) => { return keyname !== statusLables })], "branchSearch", "locCode")
                                                            }
                                                        } else {
                                                            console.log('not all and not labeled')
                                                            setBranchFilter([statusLables, ...branchFilter.filter((keyname, key) => { return keyname })])
                                                            setNewFilter([statusLables, ...branchFilter.filter((keyname, key) => { return keyname })], "branchSearch", "locCode")
                                                        }
                                                    }}>
                                                        <Checkbox checked={branchFilter?.includes(statusLables)} />
                                                        {
                                                            statusLables === "20" ?
                                                                <ListItemText primary={"Bangalore Hebbal"} />
                                                                :
                                                                statusLables === "5" ?
                                                                    <ListItemText primary={"Bangalore-BTM"} />
                                                                    :
                                                                    statusLables === "6" ?
                                                                        <ListItemText primary={"Bangalore-Indiranagar"} />
                                                                        :
                                                                        statusLables === "4" ?
                                                                            <ListItemText primary={"Chandigarh"} />
                                                                            :
                                                                            statusLables === "7" ?
                                                                                <ListItemText primary={"Chennai"} />
                                                                                :
                                                                                statusLables === "13" ?
                                                                                    <ListItemText primary={"Delhi"} />
                                                                                    :
                                                                                    statusLables === "11" ?
                                                                                        <ListItemText primary={"Dubai"} />
                                                                                        :
                                                                                        statusLables === "2" ?
                                                                                            <ListItemText primary={"Faridabad"} />
                                                                                            :
                                                                                            statusLables === "1" ?
                                                                                                <ListItemText primary={"Gurugram"} />
                                                                                                :
                                                                                                statusLables === "14" ?
                                                                                                    <ListItemText primary={"Hyderabad"} />
                                                                                                    :
                                                                                                    statusLables === "23" ?
                                                                                                        <ListItemText primary={"Jaipur"} />
                                                                                                        :
                                                                                                        statusLables === "22" ?
                                                                                                            <ListItemText primary={"Lucknow"} />
                                                                                                            :
                                                                                                            statusLables === "21" ?
                                                                                                                <ListItemText primary={"Mangalore"} />
                                                                                                                :
                                                                                                                statusLables === "18" ?
                                                                                                                    <ListItemText primary={"MDWI India"} />
                                                                                                                    :
                                                                                                                    statusLables === "8" ?
                                                                                                                        <ListItemText primary={"Mumbai-Andheri"} />
                                                                                                                        :
                                                                                                                        statusLables === "9" ?
                                                                                                                            <ListItemText primary={"Navi Mumbai"} />
                                                                                                                            :
                                                                                                                            statusLables === "12" ?
                                                                                                                                <ListItemText primary={"Noida"} />
                                                                                                                                :
                                                                                                                                statusLables === "19" ?
                                                                                                                                    <ListItemText primary={"Opportunity Card"} />
                                                                                                                                    :
                                                                                                                                    statusLables === "17" ?
                                                                                                                                        <ListItemText primary={"Other"} />
                                                                                                                                        :
                                                                                                                                        statusLables === "10" ?
                                                                                                                                            <ListItemText primary={"Pune"} />
                                                                                                                                            :
                                                                                                                                            statusLables === "16" ?
                                                                                                                                                <ListItemText primary={"Test Branch"} />
                                                                                                                                                :
                                                                                                                                                statusLables === "15" ?
                                                                                                                                                    <ListItemText primary={"Vocational"} />
                                                                                                                                                    :
                                                                                                                                                    "NA"
                                                        }
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    <TextField
                                        className='w-100'
                                        style={{ maxWidth: "300px" }}
                                        id="fromEmailSearch"
                                        label="From Email"
                                        type="search"
                                        variant="outlined"
                                        data-dbcol="from"
                                        onChange={(e) => { setNewFilter(e.target.value, "fromEmailSearch", "from") }}
                                    />
                                    <TextField
                                        className='w-100'
                                        style={{ maxWidth: "300px" }}
                                        id="toEmailSearch"
                                        label="To Email"
                                        type="search"
                                        variant="outlined"
                                        data-dbcol="to"
                                        onChange={(e) => { setNewFilter(e.target.value, "toEmailSearch", "to") }}
                                    />
                                    <TextField
                                        className='w-100'
                                        style={{ maxWidth: "300px" }}
                                        id="subjectSearch"
                                        label="Subject"
                                        type="search"
                                        variant="outlined"
                                        data-dbcol="subject"
                                        onChange={(e) => { setNewFilter(e.target.value, "subjectSearch", "subject") }}
                                    />
                                    <TextField
                                        className='w-100'
                                        style={{ maxWidth: "300px" }}
                                        id="leadIdSearch"
                                        label="Lead Id/Student Id"
                                        type="search"
                                        variant="outlined"
                                        data-dbcol="leadId"
                                        onChange={(e) => { setNewFilter(e.target.value, "leadIdSearch", "leadId") }}
                                    />
                                </div>
                            </motion.div>
                        }
                    </AnimatePresence>


                </div>

                <div className='d-flex align-items-start flex-column gap-1 h-100 w-100 overflow-hidden'>
                    <div className='w-100 h-100 overflow-auto'>
                        {
                            !loadingEntries ?
                                dataWithDate ?
                                    <table className='table table-yesgermany table-light m-0'>
                                        <thead className='table-success sticky-top'>
                                            <tr>
                                                <th valign="middle" className='text-nowrap text-center'>#{totalEntriesCount ? totalEntriesCount : 0}</th>
                                                <th valign="middle" className='text-nowrap text-center'>Time</th>
                                                {/* <th valign="middle" className='text-nowrap text-center'>Message ID</th> */}
                                                <th valign="middle" className='text-nowrap text-center'>Lead ID</th>
                                                <th valign="middle" className='text-nowrap text-center'>Subject</th>
                                                <th valign="middle" className='text-nowrap text-center'>From</th>
                                                <th valign="middle" className='text-nowrap text-center'>To</th>
                                                <th valign="middle" className='text-nowrap text-center'>Attachments</th>
                                                <th valign="middle" className='text-nowrap text-center'>Status</th>
                                                <th valign="middle" className='text-nowrap text-center'>Actionable</th>
                                                <th valign="middle" className='text-nowrap text-center'>Category</th>
                                                <th valign="middle" className='text-nowrap text-center'>Priority</th>
                                                <th valign="middle" className='text-nowrap text-center'>Follow-Up Date</th>
                                                <th valign="middle" className='text-nowrap text-center'>Deadline Date</th>
                                                <th valign="middle" className='text-nowrap text-center'>Interview Date</th>
                                                <th valign="middle" className='text-nowrap text-center'>Updated By</th>
                                                <th valign="middle" className='text-nowrap text-center'>Updated On</th>
                                                <th valign="middle" className='text-nowrap text-center'>Remarks</th>
                                                <th valign="middle" className='text-nowrap text-center'>Auditor Name</th>
                                                <th valign="middle" className='text-nowrap text-center'>Auditor Status</th>
                                                <th valign="middle" className='text-nowrap text-center'>Auditor's Comment</th>
                                                <th valign="middle" className='text-nowrap text-center'>Audit On</th>
                                            </tr>
                                        </thead>
                                        {
                                            Object.keys(dataWithDate).map((data, key) => {
                                                return (
                                                    <tbody key={key}>
                                                        <tr>
                                                            <td colSpan={100}>
                                                                <div className='alert alert-success rounded-pill m-0 d-flex gap-3 align-items-center overflow-hidden w-100' style={{ padding: "0 0 0 0" }}>
                                                                    <span className='btn btn-success px-2 py-0 m-0'>{dataWithDate[data].length} Emails on this page</span>
                                                                    <span className='text-nowrap fw-bold'>{data}</span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {
                                                            dataWithDate[data] ?
                                                                dataWithDate[data].length > 0 ?
                                                                    dataWithDate[data].map((message, key) => {
                                                                        return (
                                                                            <tr key={key}>
                                                                                <td valign='middle' className='text-center'>{key + 1}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{dayjs(message.date).format("hh:mm A")}</td>
                                                                                {/* <td valign='middle' className='text-center text-nowrap'>{message._id}</td> */}
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.leadId}</td>
                                                                                <td valign='middle' className='text-center text-success text-nowrap fw-bold text-truncate' style={{ cursor: "pointer", maxWidth: "450px" }} onClick={() => { showTheMessage(message._id) }}>{message.subject}</td>
                                                                                <td valign='middle' className='text-center text-nowrap text-truncate' style={{ maxWidth: "250px" }}>{message.from.value[0].address}</td>
                                                                                <td valign='middle' className='text-center text-nowrap text-truncate' style={{ maxWidth: "250px" }}>{message.to ? message.to : message.headerLines.filter((data) => { return data.key === "envelope-to" })[0]?.line.replaceAll("Envelope-to:", "").toLowerCase()}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{JSON.stringify(message.attachments?.length)}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.mailStatus}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.actionable}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.mailCategory}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.priority}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.followUpDate ? dayjs(message.followUpDate).format("DD MMM YYYY hh:mmA") : ""}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.followUpDate ? dayjs(message.deadlineDate).format("DD MMM YYYY hh:mmA") : ""}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.interviewDate}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{message.updatedBy?.email}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{dayjs(message.updatedAt).format("DD MMM YYYY hh:mmA")}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{JSON.stringify(message.remarks)}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'>{JSON.stringify(message.auditorRemarks)}</td>
                                                                                <td valign='middle' className='text-center text-nowrap'></td>
                                                                                <td valign='middle' className='text-center text-nowrap'></td>
                                                                                <td valign='middle' className='text-center text-nowrap'></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={100}></td>
                                                                    </tr>
                                                                :
                                                                <tr>
                                                                    <td colSpan={100}></td>
                                                                </tr>
                                                        }
                                                    </tbody>
                                                )
                                            })
                                        }
                                    </table>
                                    :
                                    <div className='h-100 w-100 d-flex align-items-center justify-content-center'>
                                        No Data Availabel
                                    </div>
                                :
                                <div className='h-100 w-100 d-flex align-items-center justify-content-center'>
                                    <CustomSpinner size={1} />
                                </div>
                        }
                    </div>
                    <div className='w-100 mt-2 customBackgroundFilter rounded'>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Pagination: {
                                        itemActiveBg: "#faf089",
                                        itemActiveBgDisabled: "yellow",
                                        // itemActiveColorDisabled: "",
                                        // itemBg: "",
                                        // itemInputBg: "",
                                        // itemLinkBg: "",

                                    },
                                },
                                token: {
                                    // colorBgContainer: "",
                                    // colorBgContainerDisabled: "",
                                    // colorBgTextActive: "",
                                    colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                    // colorBorder: "red",
                                    // colorPrimary: "",
                                    // colorPrimaryBorder: "#faf089",
                                    // colorPrimaryHover: "",
                                    // colorText: "",
                                    // colorTextDisabled: "",
                                    // colorTextPlaceholder: "",
                                    // borderRadius: "",
                                    // borderRadiusLG: "",
                                    // borderRadiusSM: "",
                                    // controlHeight: "",
                                    // controlOutline: "",
                                    // controlOutlineWidth: "",
                                    // fontFamily: "",
                                    // fontSize: "",
                                    // lineHeight: "",
                                    margin: 0,
                                    // motionDurationMid: "",
                                    // paddingXXS: ""
                                }
                            }}
                        >
                            <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                        </ConfigProvider>
                    </div>
                </div>
            </div>



            <Modal show={showMyMessage} size='xl' onHide={() => { setShowMyMessage(false) }} backdrop="static" centered>
                <form onSubmit={(e) => { updateThisEmail(e, myMessage._id) }}>
                    <Modal.Header closeButton>
                        <Modal.Title className='d-flex flex-column gap-2 w-100'>
                            <div className='d-flex align-items-center gap-3 alert alert-success p-0 m-0 w-100'>
                                <button className='btn btn-success rounded-3 m-0 d-flex gap-3 align-items-center'>
                                    <span className='text-nowrap'>Subject : </span>
                                </button> {myMessage ? myMessage.subject : ""}
                            </div>
                            <div className='d-flex align-items-center gap-3 alert alert-success p-0 m-0 w-100'>
                                <button className='btn btn-success py-0 rounded-3 m-0 d-flex gap-3 align-items-center w-100' style={{ maxWidth: "120px" }}>
                                    <span className='text-nowrap fs-6'>From : </span>
                                </button>
                                <span className='fs-6'>
                                    {
                                        myMessage ? myMessage.from.value[0].address : ""
                                    }
                                </span>

                            </div>
                            <div className='d-flex align-items-center gap-3 alert alert-success p-0 m-0 w-100'>
                                <button className='btn btn-success py-0 rounded-3 m-0 d-flex gap-3 align-items-center w-100' style={{ maxWidth: "120px" }}>
                                    <span className='text-nowrap fs-6'>To : </span>
                                </button>
                                <span className='fs-6'>
                                    {
                                        myMessage ?
                                            myMessage.to ?
                                                myMessage.to
                                                :
                                                myMessage.headerLines.filter((data) => { return data.key === "envelope-to" })[0]?.line.replaceAll("Envelope-to:", "").toLowerCase()
                                            :
                                            ""
                                    }
                                </span>
                            </div>
                            <div className='d-flex align-items-center gap-3 alert alert-success p-0 m-0 w-100'>
                                <button className='btn btn-success py-0 rounded-3 m-0 d-flex gap-3 align-items-center w-100' style={{ maxWidth: "120px" }}>
                                    <span className='text-nowrap fs-6'>Date : </span>
                                </button>
                                <span className='fs-6'>
                                    {
                                        myMessage ?
                                            dayjs(myMessage.date).format("DD MMMM YYYY, hh:mmA")
                                            :
                                            ""
                                    }
                                </span>
                            </div>
                            <div className='d-flex align-items-center gap-3 alert alert-success p-0 m-0'>
                                <button className='btn btn-success py-0 rounded-3 m-0 d-flex gap-3 align-items-center w-100' style={{ maxWidth: "120px" }}>
                                    <span className='text-nowrap fs-6'>Attachments : </span>
                                </button>
                                <div className='fs-6 d-flex gap-2'>
                                    {
                                        mailAttachments ?
                                            mailAttachments.attachments.map((data, key) => {
                                                const arrayBuffer = data.content.data
                                                const contentType = data.contentType
                                                const fileName = `${dayjs(myMessage.date).format("DD_MMMM_YYYY_hh-mm-ssA")}_${data.filename ? data.filename : myMessage.leadId}.${data.contentType?.split("/")[1]}`
                                                return (
                                                    <button type="button" className='btn btn-sm btn-secondary rounded' key={key} onClick={(e) => { downloadBufferAsFile(arrayBuffer, contentType, fileName) }}>{fileName}</button>
                                                )
                                            })
                                            :
                                            ""
                                    }
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='d-flex flex-column gap-3'>
                        <div className=' w-100 text-wrap' style={{ wordBreak: "break-all" }}>

                            {
                                myMessage ?
                                    parse(myMessage.textAsHtml)
                                    :
                                    ""
                            }
                        </div>

                        <div className='d-flex justify-content-between flex-wrap gap-2 bg-light p-2'>
                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Type</span>
                                <ReactSelect
                                    value={selectedType}
                                    onChange={(e) => { setSelectedType(e); makeMandatoryFormOrNot(e.label) }}
                                    options={[
                                        { "label": "Pending", "value": "Pending" },
                                        { "label": "Actionable", "value": "Actionable" },
                                        { "label": "No Action", "value": "no-action" }
                                    ]}
                                />
                            </label>
                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Category</span>
                                <ReactSelect
                                    required={isCategoryRequired}
                                    value={categryOption}
                                    onChange={(e) => { setCategoryOption(e); setSelectedLabel(labelOptions[e.label]); setSelectedCategoryOption(null); }}
                                    options={
                                        Object.keys(labelOptions).map((keyname, key) => {
                                            return { "label": keyname, "value": keyname }
                                        })
                                    }
                                />

                            </label>
                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Category Options</span>

                                <ReactSelect
                                    required={isCategoryOptionRequired}
                                    value={selectedCategoryOption}
                                    onChange={(e) => { setSelectedCategoryOption(e); }}
                                    options={
                                        selectedLabel?.map((keyname, key) => {
                                            return { "label": keyname, "value": keyname }
                                        })
                                    }
                                />
                            </label>
                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Priority</span>
                                <ReactSelect
                                    required={isPriorityRequired}
                                    value={priority}
                                    onChange={(e) => { setPriority(e); }}
                                    options={[
                                        { "label": "Low", "value": "Low" },
                                        { "label": "Medium", "value": "Medium" },
                                        { "label": "High", "value": "High" },

                                    ]}
                                />

                            </label>
                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Status</span>
                                <ReactSelect
                                    required={isStatusRequired}
                                    value={status}
                                    onChange={(e) => { setStatus(e); }}
                                    options={[
                                        { "label": "Closed", "value": "closed" },
                                        { "label": "In-Process", "value": "in-process" },
                                        { "label": "In-Process by Student", "value": "in-process-by-student" },
                                        { "label": "open", "value": "open" },
                                        { "label": "re-open", "value": "re-open" },
                                    ]}
                                />
                            </label>

                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Deadline Date</span>
                                <div className='d-flex gap-1'>
                                    <OverlayTrigger
                                        trigger="click"
                                        placement={"top"}
                                        onToggle={() => { setShowCalendarDeadline(!showCalendarDeadline) }}
                                        show={showCalendarDeadline}
                                        overlay={
                                            <Popover id={`popover-positioned-`}>
                                                <Popover.Header as="h3">Pick a Date</Popover.Header>
                                                <Popover.Body className='p-0'>
                                                    <Calendar onChange={(e) => { setDeadlineDate(e); setShowCalendarDeadline(false) }} value={deadlineDate} minDate={new Date()} />
                                                </Popover.Body>
                                            </Popover>
                                        }>
                                        <input type='text' className='form-control' id="deadlineDate" value={deadlineDate ? dayjs(deadlineDate).format("DD-MMMM-YYYY") : "DD-MMM-YYYY"} onChange={() => { }} />
                                    </OverlayTrigger>
                                    <input type="time" id="deadlineTime" className='form-control w-100' value={dayjs(deadlineDate).format("HH:mm")} onChange={() => { }} />
                                </div>
                            </label>

                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Follow Up Date</span>
                                <div className='d-flex gap-1'>
                                    <OverlayTrigger
                                        trigger="click"
                                        placement={"top"}
                                        onToggle={() => { setShowCalendarFollowup(!showCalendarFollowup) }}
                                        show={showCalendarFollowup}
                                        overlay={
                                            <Popover id={`popover-positioned-`}>
                                                <Popover.Header as="h3">Pick a Date</Popover.Header>
                                                <Popover.Body className='p-0'>
                                                    <Calendar onChange={(e) => { setFollowDate(e); setShowCalendarFollowup(false) }} value={followDate} minDate={new Date()} maxDate={deadlineDate} />
                                                </Popover.Body>
                                            </Popover>
                                        }>
                                        <input type='text' className='form-control' id="followUpDate" value={followDate ? dayjs(followDate).format("DD-MMMM-YYYY") : "DD-MMM-YYYY"} onChange={() => { }} />
                                    </OverlayTrigger>
                                    <input type="time" id="followUpTime" className='form-control w-100' value={dayjs(followDate).format("HH:mm")} onChange={() => { }} />
                                </div>
                            </label>

                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Interview Date</span>
                                <div className='d-flex gap-1'>
                                    <OverlayTrigger
                                        trigger="click"
                                        placement={"top"}
                                        onToggle={() => { setShowCalendarInterviewDate(!showCalendarInterviewDate) }}
                                        show={showCalendarInterviewDate}
                                        overlay={
                                            <Popover id={`popover-positioned-`}>
                                                <Popover.Header as="h3">Pick a Date</Popover.Header>
                                                <Popover.Body className='p-0'>
                                                    <Calendar onChange={(e) => { setInterviewDate(e); setShowCalendarInterviewDate(false) }} value={interviewDate} minDate={new Date()} maxDate={deadlineDate} />
                                                </Popover.Body>
                                            </Popover>
                                        }>
                                        <input type='text' className='form-control' id="followUpDate" value={interviewDate ? dayjs(interviewDate).format("DD-MMMM-YYYY") : "DD-MMM-YYYY"} onChange={() => { }} />
                                    </OverlayTrigger>
                                    <input type="time" id="interviewDateTime" className='form-control w-100' value={dayjs(interviewDate).format("HH:mm")} onChange={() => { }} />
                                </div>
                            </label>

                            <label htmlFor="" className="w-100" style={{ maxWidth: "30%" }}>
                                <span>Remarks</span>
                                <textarea className='form-control w-100' defaultValue={remarks} required={isRemarRequired} onInput={(e) => { setRemarks(e.target.value) }}></textarea>
                            </label>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-center gap-3 w-100'>
                            <button type="submit" className='btn btn-sm btn-success rounded-pill w-100 shadow-sm' style={{ maxWidth: "120px" }}>Update</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal >
        </>
    )
}

export default Mailer